/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_MENU_LANGUAGE_OPTIONS_LIST = 'SET_MENU_LANGUAGE_OPTIONS_LIST';
export const SET_MENU_LANGUAGE_SELECTED_OPTION = 'SET_MENU_LANGUAGE_SELECTED_OPTION';
